// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Title-module__root--Apia4 {
  display: flex;
  align-items: center;
}

.Title-module__orientation-vertical--Hdmxi {
  flex-direction: column;
}
.Title-module__title--KfFdc {
  flex: 1;
  color: #1A1A1A;
  align-items: center;
}

.Title-module__title--KfFdc * {
  vertical-align: top;
}

.Title-module__description--Pn5od {
  margin-top: 8px;
  font-size: 14px;
  color: #777777;
  font-weight: normal;
}

.Title-module__root--Apia4 .Title-module__trailing--QoqO1 {
  text-align: right;
  display: inline-flex;
  align-items: center;
}

.Title-module__root--Apia4 .Title-module__trailing--QoqO1 > * {
  margin-left: 8px;
}

.Title-module__level-page--ksj7Z .Title-module__title--KfFdc {
  font-size: 2.5rem; /* 40px */
  font-weight: 600;
}

.Title-module__level-main--RYqok .Title-module__title--KfFdc {
  font-size: 2.125rem; /* 34px */
  font-weight: 600;
}

.Title-module__level-caption--TVsrQ .Title-module__title--KfFdc {
  font-size: 0.8125rem; /* 13px */
  font-weight: 700;
  color: #777777;
}

.Title-module__orientation-vertical--Hdmxi { 
  align-items: stretch;
}

.Title-module__orientation-vertical--Hdmxi .Title-module__title--KfFdc {
  flex: unset;
}

.Title-module__orientation-vertical--Hdmxi .Title-module__trailing--QoqO1 {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  margin-top: 30px;
}

.Title-module__orientation-vertical--Hdmxi .Title-module__trailing--QoqO1 > * {
  text-align: left;
  margin-left: 0;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Title/Title.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,OAAO;EACP,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB,EAAE,SAAS;EAC5B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB,EAAE,SAAS;EAC9B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB,EAAE,SAAS;EAC/B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":[".root {\n  display: flex;\n  align-items: center;\n}\n\n.orientation-vertical {\n  flex-direction: column;\n}\n.title {\n  flex: 1;\n  color: #1A1A1A;\n  align-items: center;\n}\n\n.title * {\n  vertical-align: top;\n}\n\n.description {\n  margin-top: 8px;\n  font-size: 14px;\n  color: #777777;\n  font-weight: normal;\n}\n\n.root .trailing {\n  text-align: right;\n  display: inline-flex;\n  align-items: center;\n}\n\n.root .trailing > * {\n  margin-left: 8px;\n}\n\n.level-page .title {\n  font-size: 2.5rem; /* 40px */\n  font-weight: 600;\n}\n\n.level-main .title {\n  font-size: 2.125rem; /* 34px */\n  font-weight: 600;\n}\n\n.level-caption .title {\n  font-size: 0.8125rem; /* 13px */\n  font-weight: 700;\n  color: #777777;\n}\n\n.orientation-vertical { \n  align-items: stretch;\n}\n\n.orientation-vertical .title {\n  flex: unset;\n}\n\n.orientation-vertical .trailing {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  flex: 1;\n  margin-top: 30px;\n}\n\n.orientation-vertical .trailing > * {\n  text-align: left;\n  margin-left: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Title-module__root--Apia4`,
	"orientation-vertical": `Title-module__orientation-vertical--Hdmxi`,
	"title": `Title-module__title--KfFdc`,
	"description": `Title-module__description--Pn5od`,
	"trailing": `Title-module__trailing--QoqO1`,
	"level-page": `Title-module__level-page--ksj7Z`,
	"level-main": `Title-module__level-main--RYqok`,
	"level-caption": `Title-module__level-caption--TVsrQ`
};
export default ___CSS_LOADER_EXPORT___;
